// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleFilledSvg from "@fishx/icons-svg/es/asn/EyeInvisibleFilled";
import FishxIcon from '../components/FishxIcon';

var EyeInvisibleFilled = function EyeInvisibleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleFilledSvg
  }));
};

EyeInvisibleFilled.displayName = 'EyeInvisibleFilled';
export default React.forwardRef(EyeInvisibleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EyeInvisibleFilled.js
// module id = 2654
// module chunks = 0